import React, {Component} from 'react'
import './FlipCard'
import FlipCard from './FlipCard'
class Project extends Component{
    render(){
        return(
            <div style={{textAlign:'center', paddingTop: '2%'}}>
                <h1><u>Projects ⏯</u></h1>
                <FlipCard/>
            </div>
        )
    }
}
export default Project